import { render } from "./DocumentSplit.vue?vue&type=template&id=5957a20f&scoped=true&ts=true"
import script from "./DocumentSplit.vue?vue&type=script&lang=ts"
export * from "./DocumentSplit.vue?vue&type=script&lang=ts"

import "./DocumentSplit.vue?vue&type=style&index=0&id=5957a20f&lang=scss&scoped=true"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5957a20f"]])

export default __exports__